module.exports = __webpack_public_path__ + "img/collar edges length peter pen or flat 17=1.ba9c1aaa.png";